<template>
  <div id="app">
    <div class="container-fluid">
      <navbar></navbar>
      <heading></heading>
      <a v-if="bouncingArrowHidden" href="#about"><i class="fas fa-chevron-circle-down bounce"></i></a>
      <about></about>
      <resume></resume>
      <portfolio></portfolio>
      <!-- <contact></contact> -->
      <page-footer></page-footer>
    </div>

    <!-- Modals -->
    <disclaimer v-if="disclaimerShown" ref="disclaimer"></disclaimer>
    <portfolio-details v-if="portfolioShown" ref="portfolio"></portfolio-details>

    <!-- Alerts -->
    <message-status v-if="messageStatusShown" ref="messageStatus"></message-status>
  </div>
</template>

<script>
import breakpoint from '@/util/breakpoint';
import { mapState, mapActions } from 'vuex';

/* General page components */
import Navbar from '@/components/Navbar.vue';
import PageFooter from '@/components/PageFooter.vue';

/* Sections */
import Heading from '@/sections/Heading.vue';
import About from '@/sections/About.vue';
import Resume from '@/sections/Resume.vue';
import Portfolio from '@/sections/Portfolio.vue';
import Contact from '@/sections/Contact.vue';

/* Modals */
import Disclaimer from '@/modals/Disclaimer.vue';
import PortfolioDetails from '@/modals/PortfolioDetails.vue';

/* Alerts */
import MessageStatus from '@/alerts/MessageStatus.vue';

export default {
  name: 'app',
  mixins: [breakpoint],
  components: {
    /* General page components */
    Navbar,
    PageFooter,

    /* Sections */
    Heading,
    About,
    Resume,
    Portfolio,
    Contact,

    /* Modals */
    Disclaimer,
    PortfolioDetails,

    /* Alerts */
    MessageStatus
  },
  data(){
    return {
      SCROLL_POSITION_Y_BREAKPOINT: 200,
      bouncingArrowHidden: false
    }
  },
  created() {
    document.documentElement.style.scrollBehavior = "smooth"; // to add smooth scroll behaviour
  },
  computed: {
    ...mapState(['scrollPosition_y', 'disclaimerShown', 'portfolioShown', 'messageStatusShown']),
    triggerDisclaimerModal: function(){
      if (this.disclaimerShown){
        setTimeout(() => {
          const el = this.$refs.disclaimer.$el;
          $(el).modal({backdrop: 'static', keyboard: false});
        }, 500);
      }
      
      return this.disclaimerShown
    },
    triggerMessageAlert: function(){
      if (this.messageStatusShown){
        setTimeout(() => {
          $('.alert').alert();

          setTimeout(() => {
            $('.alert').alert('close');
            this.showMessageStatus({shown: false});
          }, 3000);
        }, 500);
      }
      
      return this.messageStatusShown;
    }
  },
  watch: {
    triggerDisclaimerModal(){},
    triggerMessageAlert(){}
  },
  methods: {
    ...mapActions(['getScrollPosition', 'showMessageStatus']),
    hideBouncingArrow: function() {
      if (this.scrollPosition_y < this.SCROLL_POSITION_Y_BREAKPOINT) {
        this.bouncingArrowHidden = true;
      } 
      else {
        this.bouncingArrowHidden = false;
      }
    }
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('scroll', this.getScrollPosition);
      window.addEventListener('scroll', this.hideBouncingArrow);
      this.hideBouncingArrow();
    });
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.getScrollPosition);
    window.removeEventListener('scroll', this.hideBouncingArrow);
  }
}
</script>

<style lang="scss" scoped>
.fa-chevron-circle-down {
  position: absolute;
  color: $colour-blue-primary;
  right: 5vw;
  bottom: 5vh;
  font-size: 2.45em;
  animation: bounce 2s infinite;
}

body {
  position: relative;
}
</style>
